import { FunctionComponent, ReactNode } from "react";

const WithIcon: FunctionComponent<{
  icon: ReactNode;
  top?: boolean;
  iconClassName?: string;
}> = ({ icon, top, iconClassName, children }) => {
  return (
    <span className={`flex ${top ? "items-start" : "items-center"} space-x-2`}>
      <span className={`${iconClassName || ""}`}>{icon}</span>
      <span>{children}</span>
    </span>
  );
};

export default WithIcon;
